import { useState } from 'react';

import { PDF_SCALE } from './usePdfRenderer';

const ZOOM_STEP = 0.25;
const MIN_SCALE = 0.5;
const MAX_SCALE = 4;

export function usePdfZoom() {
  const [scale, setScale] = useState(PDF_SCALE);

  const zoomIn = () => {
    setScale((previousScale) => Math.min(previousScale + ZOOM_STEP, MAX_SCALE));
  };

  const zoomOut = () => {
    setScale((previousScale) => Math.max(previousScale - ZOOM_STEP, MIN_SCALE));
  };

  return {
    scale,
    zoomPercentage: Math.round((scale / PDF_SCALE) * 100),
    zoomIn,
    zoomOut,
    canZoomIn: scale < MAX_SCALE,
    canZoomOut: scale > MIN_SCALE,
  };
}
